import { Mapper } from 'planning-portal-library/src/lib/core/base';
import { UserRulesTemplate } from 'planning-portal-library/src/lib/core/domain/models/user-rules-template';
import { UserRulesTemplateWebEntity } from './user-rules-template.web-entity';

export class UserRulesTemplateRepositoryMapper extends Mapper<
  UserRulesTemplateWebEntity,
  UserRulesTemplate
> {
  mapFrom(param: UserRulesTemplateWebEntity): UserRulesTemplate {
    return {
      id: param.id,
      title: param.title,
      vehicleProfile: param.vehicleProfile,
      serviceFrequency: param.serviceFrequency,
      includeSnapIn: param.includeSnapIn,
      serviceTime: param.serviceTime,
      snapInDistance: param.snapInDistance,
      snapInSpeed: param.snapInSpeed,
      speedOverride: param.speedOverride,
      targetJobDuration: param.targetJobDuration,
      microSegmantSize: param.microSegmantSize,
      targetSegmantDuration: param.targetSegmantDuration,
      startLocationLatitude: param.startLocationLatitude,
      startLocationLongitude: param.startLocationLongitude,
      endLocationLatitude: param.endLocationLatitude,
      endLocationLongitude: param.endLocationLongitude,
      description: param.description,
      startLocationAddress: param.startLocationAddress,
      endLocationAddress: param.endLocationAddress,
    };
  }

  mapTo(param: UserRulesTemplate): UserRulesTemplateWebEntity {
    return {
      id: param.id,
      title: param.title,
      vehicleProfile: param.vehicleProfile,
      serviceFrequency: param.serviceFrequency,
      includeSnapIn: param.includeSnapIn,
      serviceTime: param.serviceTime,
      snapInDistance: param.snapInDistance,
      snapInSpeed: param.snapInSpeed,
      speedOverride: param.speedOverride,
      targetJobDuration: param.targetJobDuration,
      microSegmantSize: param.microSegmantSize,
      targetSegmantDuration: param.targetSegmantDuration,
      startLocationLatitude: param.startLocationLatitude,
      startLocationLongitude: param.startLocationLongitude,
      endLocationLatitude: param.endLocationLatitude,
      endLocationLongitude: param.endLocationLongitude,
      description: param.description,
      startLocationAddress: param.startLocationAddress,
      endLocationAddress: param.endLocationAddress,
    };
  }
}
